import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { object, string } from "yup";
import AdminFormModal from "../../AdminFormModal";
import { Form, Button, Row, Space } from "@masterteam/mt-design-react";

import { ReactComponent as NotificationsIcon } from "../../../assets/images/admin-noti.svg";
import { addToast } from "../../../helpers";
import api from "../../../providers/api";

import "./style.scss";

const { Field } = Form;

const validationSchema = object().shape({
  NotificationArabic: string().required(" "),
  NotificationEnglish: string().required(" "),
  EmailSubject: string().required(" "),
  EmailBody: string().required(" "),
});

const NotificationForm = ({ data, closeModal, callback }) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    NotificationEnglish: "",
    NotificationArabic: "",
    EmailSubject: "",
    EmailBody: "",
  });

  const getNotificationData = () => {
    setLoading(true);
    api.notification
      .getConfigById(data?.ID)
      .then((res) => {
        setInitialValues(res.Data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (data) {
      getNotificationData();
    }
  }, []);

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const body = {
        ...values,
      };
      const res = await api.notification.updateConfig(body);
      const { Data, StatusCode } = res;
      if (StatusCode === "Success") {
        callback(Data);
      }
    } catch (error) {
      addToast.error(error?.message, {
        toastId: "get-users-error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminFormModal
      title={intl.formatMessage({ id: "common.notification" })}
      Icon={NotificationsIcon}
      isLoading={loading}
      onClose={closeModal}
    >
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, isSubmitting, isValid, setFieldValue }) => (
          <>
            <Space
              direction="vertical"
              size="medium"
              className="notification-config-form"
            >
              <div direction="vertical" className="form-container">
                <Field
                  name="Title"
                  label={intl.formatMessage({ id: "notification.event" })}
                  disabled
                  inputProps={{
                    placeholder: intl.formatMessage({
                      id: "notification.event",
                    }),
                  }}
                />
                <Row size="small">
                  <Field
                    name="NotificationEnglish"
                    label={intl.formatMessage({
                      id: "notification.english-message",
                    })}
                    inputProps={{
                      placeholder: intl.formatMessage({
                        id: "notification.english-message",
                      }),
                    }}
                    required
                  />
                  <Field
                    name="NotificationArabic"
                    label={intl.formatMessage({
                      id: "notification.arabic-message",
                    })}
                    inputProps={{
                      placeholder: intl.formatMessage({
                        id: "notification.arabic-message",
                      }),
                    }}
                    required
                  />
                </Row>
                <Field
                  name="EmailSubject"
                  label={intl.formatMessage({
                    id: "notification.email-subject",
                  })}
                  inputProps={{
                    placeholder: intl.formatMessage({
                      id: "notification.email-subject",
                    }),
                  }}
                  required
                />
                <Field
                  type="textarea"
                  name="EmailBody"
                  label={intl.formatMessage({
                    id: "notification.email-body",
                  })}
                  inputProps={{
                    placeholder: intl.formatMessage({
                      id: "notification.email-body",
                    }),
                  }}
                  required
                />
              </div>
              <Row justify="end" className="form-footer">
                <Button
                  loading={isSubmitting}
                  disabled={!isValid}
                  variant="primary"
                  type="submit"
                  fixed
                >
                  {intl.formatMessage({ id: "common.update" })}
                </Button>
              </Row>
            </Space>
          </>
        )}
      </Form>
    </AdminFormModal>
  );
};

export default NotificationForm;
